import { render, staticRenderFns } from "./AlgorithmClassView.vue?vue&type=template&id=97639d74&scoped=true&"
import script from "./AlgorithmClassView.vue?vue&type=script&lang=js&"
export * from "./AlgorithmClassView.vue?vue&type=script&lang=js&"
import style0 from "./AlgorithmClassView.vue?vue&type=style&index=0&id=97639d74&prod&lang=scss&scoped=true&"
import style1 from "./AlgorithmClassView.vue?vue&type=style&index=1&id=97639d74&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97639d74",
  null
  
)

export default component.exports